export const DISCIPLINES: Record<string, string> = {
  swim: 'Schwimmen',
  openwater: 'Freiwasser',
  bike: 'Rennrad',
  gravel: 'Gravel',
  mtb: 'Mountainbike',
  run: 'Laufen',
  tri: 'Triathlon',
  duathlon: 'Duathlon',
  swimrun: 'Swim & Run',
  strength: 'Kraft & Athletik',
  ski: 'Langlauf',
  fitness: 'Fitness',
  social: 'Vereinsleben',
  other: 'Sonstiges',
};
export const TYPES: Record<string, string> = {
  training: 'Training',
  brick: 'Koppeltraining',
  tech: 'Technik',
  interval: 'Intervall',
  mount: 'Bergtraining',
  test: 'Leistungstest',
  comp: 'Wettkampf',
  camp: 'Trainingslager',
  talk: 'Vortrag & Workshop',
  meet: 'Treffen & Feier',
  volunteer: 'Helfereinsatz',
  other: 'Sonstiges',
};

const WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
const WDL = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
export const MON = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember',
];
const pad = (n: number) => String(n).padStart(2, '0');
export const hm = (d: Date) => `${pad(d.getHours())}:${pad(d.getMinutes())}`;
export const ymd = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const wd = (d: Date) => WD[d.getDay()];
export const dShort = (d: Date) => `${WD[d.getDay()]} ${pad(d.getDate())}.${pad(d.getMonth() + 1)}.`;
/** dd.mm.yyyy */
export const dNum = (d: Date) => `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
export const dLong = (d: Date) => `${WDL[d.getDay()]}, ${d.getDate()}. ${MON[d.getMonth()]} ${d.getFullYear()}`;
const sod = (d: Date) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
export const daysUntil = (d: Date) => Math.round((sod(d).getTime() - sod(new Date()).getTime()) / 86_400_000);
export const rel = (d: Date) => {
  const n = daysUntil(d);
  return n === 0 ? 'heute' : n === 1 ? 'morgen' : n === -1 ? 'gestern' : n > 1 ? `in ${n} Tagen` : `vor ${-n} Tagen`;
};
export const ago = (d: Date) => {
  const m = Math.round((Date.now() - d.getTime()) / 60000);
  if (m < 1) return 'gerade eben';
  if (m < 60) return `vor ${m} Min.`;
  const h = Math.round(m / 60);
  if (h < 24) return `vor ${h} Std.`;
  const days = Math.round(h / 24);
  return days === 1 ? 'gestern' : days < 30 ? `vor ${days} Tagen` : `am ${dNum(d)}`;
};
export const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;
export const eventEnd = (e: { starts_at: string; ends_at: string | null; duration_min: number | null }) =>
  e.ends_at ? new Date(e.ends_at) : new Date(new Date(e.starts_at).getTime() + (e.duration_min || 0) * 60000);
export function timeLabel(e: { starts_at: string; ends_at: string | null; duration_min: number | null }) {
  const s = new Date(e.starts_at);
  if (e.ends_at && ymd(new Date(e.ends_at)) !== ymd(s)) return `${hm(s)} · bis ${dShort(new Date(e.ends_at))}`;
  return e.duration_min || e.ends_at ? `${hm(s)}–${hm(eventEnd(e))}` : hm(s);
}
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map(s => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
export const hueOf = (id: number) => (id * 47 + 200) % 360;

/** Initial "Dauer" choice of the event form: 0 = with end (date + time), -1 = open, else minutes. */
export const durationChoice = (e?: { ends_at: string | null; duration_min: number | null }) =>
  !e ? 90 : e.ends_at ? 0 : (e.duration_min ?? -1);

/** Status that "Rückgängig" restores after a quick RSVP change (waitlist counts as a sign-up). */
export const undoStatus = (before: 'none' | 'yes' | 'wait' | 'maybe'): 'none' | 'yes' | 'maybe' =>
  before === 'wait' ? 'yes' : before;

// ---- Flohmarkt ----
export const ARTICLE_CATEGORIES = ['Rad', 'Laufen', 'Schwimmen', 'Wintersport', 'Bekleidung', 'Sonstiges'] as const;
export const ARTICLE_CONDITIONS = ['Neu', 'Wie neu', 'Gebraucht', 'Bastler'] as const;
export const ARTICLE_STATUS: Record<'active' | 'reserved' | 'sold', string> = {
  active: 'Verfügbar',
  reserved: 'Reserviert',
  sold: 'Verkauft',
};
/** 1200 → "1.200 €"; null → "Preis auf Anfrage" */
export const euro = (n: number | null) => (n === null ? 'Preis auf Anfrage' : `${n.toLocaleString('de-DE')} €`);
/** Price input "1.200", "1200 €", "35,50" → whole euros (rounded), '' → null, nonsense → undefined */
export function parseEuro(text: string): number | null | undefined {
  const t = text.trim().replace(/€/g, '').replace(/\s/g, '');
  if (!t) return null;
  if (!/^\d{1,3}(\.\d{3})*(,\d{1,2})?$|^\d+(,\d{1,2})?$/.test(t)) return undefined;
  return Math.round(Number(t.replace(/\./g, '').replace(',', '.')));
}
/**
 * Order of the sport filter chips: the person's top 3 sports first (at least 2 sign-ups in the last 12 months; more
 * sign-ups first, a tie keeps the usual order), then all others in the usual order. `top`: how many come first.
 */
export function chipOrder(counts: Record<string, number> | undefined, keys = Object.keys(DISCIPLINES)) {
  const top = keys
    .filter(k => (counts?.[k] ?? 0) >= 2)
    .sort((a, b) => counts![b] - counts![a] || keys.indexOf(a) - keys.indexOf(b))
    .slice(0, 3);
  return { order: [...top, ...keys.filter(k => !top.includes(k))], top: top.length };
}
/** Top disciplines of a member, most frequent first */
export const topDisciplines = (d: Record<string, number>, n = 4) =>
  Object.entries(d)
    .sort((a, b) => b[1] - a[1])
    .slice(0, n);
/** Created within the last `days` days (e.g. the "Neu" badge) */
export const isRecent = (iso: string, days: number) => Date.now() - new Date(iso).getTime() < days * 86_400_000;
